import moment from "moment";
import React, { useState } from "react";
import jwt_decode from "jwt-decode";
import { EncodeURIComponentSafe } from "../../../../../Library/GlobalHelper";
import { How2UseQR } from "./CompUI";
import { UPDATE_ATD_LECTURER } from "../../../APIS";
import { PopUpMessage, openModal } from "../../../../../Library/ModalPopUp";
import { SessionType } from "../ConstData";
import { openToast } from "../../../../../Library/ToastPopUp";

var AuthToken = localStorage.getItem("AuthToken");
const AuthDecode = AuthToken ? jwt_decode(AuthToken) : [];


export function FormSubmitAtd({ data, setSelectedAtdid }) {
  const param_post = {
    activity_type: data?.activity_type,
    atdid: data?.id,
    end_dt: data?.end_dt,
    lec_tap_time: data?.lec_tap_time,
    remark: "",
    start_dt: data?.start_dt,
    teaching_topic: data?.teaching_topic || "",
    session_type: data?.session_type || 0,
  };
  const [post_data, setPostData] = useState(param_post);
  const isOnlyWhitespace = (str) => {
    return str.trim().length === 0;
  };
  const [submit, setSubmit] = useState({ loading: false, data: [], message: "" });
  const Update_Teaching_Topic = async () => {
    if (AuthDecode.remotedBy) {
      openToast({ header: "Error", message: "You cannot access this request" });
    } else {
      if (post_data.teaching_topic && post_data.teaching_topic !== "" && post_data.session_type !== 0) {
        const param = { ...post_data };
        param.teaching_topic = EncodeURIComponentSafe(param.teaching_topic);
        const results = await UPDATE_ATD_LECTURER(param);
        if (results.data && Object.values(results.data).length > 0) {
          openModal({ message: <PopUpMessage title={"Successfully updated"} type="success" /> })
        } else {
          openModal({ message: <PopUpMessage title={"Failed updated"} message={results.message} type="error" /> })
        }
        setSubmit(results)
      } else {
        openModal({ message: <PopUpMessage title={"Information"} message={"Please fill out this field"} /> })
      }
    }
  }

  return (
    <div>
      <div className="row">
        <div className="col-lg-8">
          <table className="table">
            <tbody>
              <tr>
                <th width="15%">Schedule</th>
                <td>
                  <span className="mr-2">
                    {data.start_dt
                      ? moment(data.start_dt).format("DD MMM YYYY")
                      : ""}
                  </span>
                  <span className="">
                    {data.start_dt ? moment(data.start_dt).format("hh:mm a") : ""}
                  </span>
                  <span className="">
                    -{data.end_dt ? moment(data.end_dt).format("hh:mm a") : ""}
                  </span>
                </td>
              </tr>
              <tr>
                <th>Status</th>
                <td>
                  {data?.status} @{" "}
                  {data.lec_tap_time
                    ? moment(data.lec_tap_time).format("D MMM YYYY hh:mm a")
                    : "-"}
                </td>
              </tr>
              <tr>
                <th>
                  Teaching Topic
                  <span className="text-danger">*</span>
                </th>
                <td>
                  <input
                    type="text"
                    name="teaching-topic"
                    autoComplete="off"
                    required
                    className="form-control required mr-2"
                    value={post_data.teaching_topic}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isOnlyWhitespace(value)) {
                        setPostData({
                          ...post_data,
                          teaching_topic: value,
                        });
                      } else {
                        setPostData({
                          ...post_data,
                          teaching_topic: "",
                        });
                      }
                    }}

                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData("text");
                      const filteredText = pastedText.replace(
                        /[^a-zA-Z0-9\s-]/g,
                        ""
                      );
                      const currentValue = e.target.value;
                      const cursorPosition = e.target.selectionStart;
                      const newValue =
                        currentValue.slice(0, cursorPosition) +
                        filteredText +
                        currentValue.slice(cursorPosition);
                      setPostData({
                        ...post_data,
                        teaching_topic: newValue.slice(0, 225),
                      });
                    }}
                    placeholder="Please fill the teaching topic for this class"
                  />
                  <span className="text-muted">
                    Please use latin alphabet and write in clear.
                  </span>
                </td>
              </tr>
              <tr>
                <th>
                  Session Type
                  <span className="text-danger">*</span>
                </th>
                <td>
                  <select
                    name="session_type"
                    className="form-control form-control-sm w-150px"
                    defaultValue={post_data.session_type}
                    disabled={data.status && data.status !== "APPROVED" ? false : true}
                    onChange={(e) =>
                      setPostData({
                        ...post_data,
                        session_type: parseInt(e.target.value),
                      })
                    }
                  >
                    <option value="0">Choose One</option>
                    {SessionType.map((v, index) => (
                      <option value={v.id} key={index}>{v.name}</option>
                    ))}
                  </select>
                </td>
              </tr>
              <tr>
                <td colSpan={2} className="text-right">
                  <div className="d-flex align-items-center justify-content-end">
                    <button
                      className="btn btn-sm btn-primary d-flex align-items-center"
                      type="button"
                      onClick={() => Update_Teaching_Topic()}
                      disabled={
                        isOnlyWhitespace(post_data.teaching_topic) || post_data.session_type === 0 ? true : submit.loading
                      }
                    >
                      <i className="fas fa-save"></i>
                      <span className="font-weight-bold">Save Changes</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        {data?.session_type !== 3 && (
          <div className="col-lg-4">
            <How2UseQR />
          </div>
        )}
      </div>
    </div>
  );
}
